export const auctionPriceUnitDisplayValues = {
  0: 'marketplace.unit.unknown',
  1: 'marketplace.unit.hour',
  2: 'marketplace.unit.day',
  3: 'marketplace.unit.month',
  4: 'marketplace.unit.square_meter',
  5: 'marketplace.unit.unit',
};
